import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { SlatePlugin } from '../../../slatePlugins/slatePlugins.types';
import { BLANK_TYPE } from '../type';
import Blank from './Blank';

interface OldBlankResultPluginOptions {
  blanks: any;
  currentSelectedIndex: any;
  showQuestionNo: any;
  testMode: any;
}

export const OldBlankResultPlugin = (options: OldBlankResultPluginOptions): SlatePlugin => {
  const { blanks, currentSelectedIndex, showQuestionNo, testMode } = options;
  return {
    voidTypes: [BLANK_TYPE],
    inlineTypes: [BLANK_TYPE],
    renderElement: (renderProps: RenderElementProps) => {
      const { element, attributes, children } = renderProps;
      if (element.type === BLANK_TYPE) {
        const blank = blanks.find((b) => b.id === element.id);
        const blankIndex = blanks.findIndex((b) => b.id === element.id);
        if (blank) {
          return (
            <BlankContainer
              style={{ display: 'inline-block', userSelect: 'none' }}
              {...attributes}
              contentEditable={false}
            >
              <Blank
                blank={blank}
                currentSelected={blankIndex === currentSelectedIndex}
                showQuestionNo={showQuestionNo}
                testMode={testMode}
              />
              {children}
            </BlankContainer>
          );
        }
      }
      return null;
    },
  };
};

const BlankContainer = styled.span`
  display: inline-block;
  margin: 0 8px;
`;
